import { connect } from 'react-redux';
import { fetchRules } from 'app/actions/contentActions';
import NestedContent from 'app/components/static/NestedContent';

function mapStateToProps(state) {
  return {
    data: state.rules.data,
    isLoading: state.rules.isLoading,
    title: 'Rules'
  };
}

const actions = {
  onMount: fetchRules
};

export default connect(mapStateToProps, actions)(NestedContent);
